import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MdaePopup, {
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupTitle,
} from "../../../../common_components/common_widgets/popup";
import MdaeButton from "../../../../common_components/common_widgets/button";
import { SET_RISK_AMOUNT_ALERT_STATUS } from "./reducers/case-data-reducer";

const RiskAmountAlertPopup = () => {
  const dispatch = useDispatch();

  const visible = useSelector(
      (state) => state["caseDataReducer"].riskAlertVisible
    );

  const notifyCloseHandler = () => {
    dispatch({
      type: SET_RISK_AMOUNT_ALERT_STATUS,
      data: { visible: false },
    });
  };
  if (!visible) return null;

  return (
    <MdaePopup
      deferRendering={false}
      height={260}
      width={500}
      visible={visible}
      className="risk-amount-alerts-popup"
      id="risk-amount-alertsStatusPopup"
      mdaeTitleRender={() => (
        <MdaePopupTitle closePopupHandler={notifyCloseHandler}>
          Alert
        </MdaePopupTitle>
      )}
      mdaeDataUpdaterConfig={[
        {
          actionType: SET_RISK_AMOUNT_ALERT_STATUS,
          reducerName: "caseDataReducer",
          widgetOptionBindings: {
            visible: "riskAlertVisible",
          },
        },
      ]}
      mdaeContentRender={() => (
        <MdaePopupContent>
          <div>
            To receive a Remit Task Alert, users must select a remit from the claim billing history
          </div>
        </MdaePopupContent>
      )}
      mdaeFooterRender={() => (
        <MdaePopupFooter>
          <MdaePopupFooterEndButtons>
            <MdaeButton
              id="pnlRiskAmountAlertsBtn"
              role="primary"
              onClick={notifyCloseHandler}
            >
              OK
            </MdaeButton>
          </MdaePopupFooterEndButtons>
        </MdaePopupFooter>
      )}
    />
  );
};

export default RiskAmountAlertPopup;
